import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';

import classes from './index.module.scss';

const Optional = () => (
    <span className={classes.optional}>
        <I18n k="orca.formControl.optional"/>
    </span>
);

export default Optional;
